import React, { lazy, Suspense } from 'react'

const SliderShowtimes = lazy(() => import('.'));

const SliderShowtimesLoading = ({
    className,
    title
}) => (
    <div className={className}>
        <div className="slider-wrapper">
            <div className="showtimes-head">
                <div className="showtimes-head-content">
                    <h2 className="showtimes-head-title headline title-xlarge-black">{title}</h2>

                    <div className="showtimes-head-button">
                        <div className="buy-ticket-large button">
                            <span className="button-text text-xlarge-bold">Showtimes</span>
                        </div>
                    </div>
                </div>

                <div className="poster-grid"></div>
            </div>
        </div>
    </div>
)

const SliderShowtimesLazy = (props) => (
    <Suspense fallback={<SliderShowtimesLoading title={props.title} className={props.scrollToPosition}/>}>
        <SliderShowtimes
            {...props}
        />
    </Suspense>
)

export default SliderShowtimesLazy